import { render, staticRenderFns } from "./generation-hour.vue?vue&type=template&id=f38590b2&scoped=true"
import script from "./generation-hour.vue?vue&type=script&lang=js"
export * from "./generation-hour.vue?vue&type=script&lang=js"
import style0 from "./generation-hour.vue?vue&type=style&index=0&id=f38590b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38590b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38590b2')) {
      api.createRecord('f38590b2', component.options)
    } else {
      api.reload('f38590b2', component.options)
    }
    module.hot.accept("./generation-hour.vue?vue&type=template&id=f38590b2&scoped=true", function () {
      api.rerender('f38590b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/generation-hour.vue"
export default component.exports